import React from 'react';
import Header from './Header';
import MovieCard from './MovieCard';
import TopicCard from './TopicCard';
import movies from '../movies';
import users from '../users';
import topics from '../topics';
import 'swiper/swiper-bundle.min.css';
import 'swiper/swiper.min.css';
import {Swiper, SwiperSlide} from 'swiper/react';


const Home = () => {
    const [current, setCurrent] = React.useState('principal')
    const [topicsClone, setTopicsClone] = React.useState([...topics])
    const [createTopic, setCreateTopic] = React.useState(false)
    return (
        <div>
            <Header />
            <div className="home">
                <div className="home__tabs">
                    <div className={`home__tabs__principal ${current==='principal' ? 'home__tabs__ativo' : ''}`} onClick={()=>{
                        setCurrent('principal')
                    }}>Principal</div>
                    <div className={`home__tabs__forum ${current==='forum' ? 'home__tabs__ativo' : ''}`} onClick={()=>{
                        setCurrent('forum')
                    }}>Fórum</div>
                </div>
                <div className="home__busca">
                    <input type="text" placeholder="Faça uma busca" />
                </div>
                <div className={`home__principal ${current==='principal' ? 'show': ''}`}>
                    <section className="home__principal__novidades">
                        <h2>Novidades</h2>
                        <Swiper
                            spaceBetween={10}
                            slidesPerView={2.5}
                        >
                            {movies.filter(movie=>movie.id>8).map(movie=>{
                                return (
                                    <SwiperSlide key={movie.id}>
                                        <MovieCard movie={movie} />
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </section>
                    <section className="home__principal__destaques">
                    <h2>Destaques</h2>
                        <Swiper
                            spaceBetween={10}
                            slidesPerView={2.5}
                        >
                            {movies.filter(movie=>movie.id<8).map(movie=>{
                                return (
                                    <SwiperSlide key={movie.id}>
                                        <MovieCard movie={movie} />
                                    </SwiperSlide>
                                )
                            })}
                        </Swiper>
                    </section>
                </div>
                <div className={`home__forum ${current==='forum' ? 'show' : ''}`}>
                            <div className={`home__forum__title ${!createTopic ? 'show--flex' : ''}`}>
                            <h2>TÓPICOS RECENTES</h2>
                            <button href="#" className="defaultBtn" onClick={()=>{
                                setCreateTopic(true)
                            }}>CRIAR NOVO</button>
                        </div>
                        <div className={`home__forum__topics ${!createTopic ? 'show' : ''}`}>
                                {
                                    topicsClone.map(topic =>{
                                        return (
                                            <TopicCard
                                            key={topic.id}
                                            topic={topic}
                                            user={users.find(user=>user.id===topic.authorId)}
                                            movieName={movies.find(movie=>movie.id===topic.movieId).nome} />
                                        );
                                    })
                                }
                            </div>
                        <div className={`home__forum__create ${createTopic? 'show' : ''}`}>
                            <h2>CRIAR NOVO TÓPICO</h2>
                            <form action="./" className="home__forum__create__form">
                                <label htmlFor="topico-titulo">TÍTULO</label>
                                <input type="text" name="topico-titulo" id="topico-titulo" minLength="5" maxLength="25" className="inputAlpha" />
                                <label htmlFor="topico-mensagem">MENSAGEM</label>
                                <textarea name="topico-mensagem" id="topico-mensagem" minLength="10" maxLength="140" cols="30" rows="10" className="inputAlpha"></textarea>
                                <input type="submit" value="PUBLICAR" className="defaultBtn" onClick={e=>{
                                    e.preventDefault()
                                    let topicData = new FormData(e.target.parentElement)
                                    let lastTopicId = topicsClone[topicsClone.length-1].id
                                    setTopicsClone([{
                                        id: lastTopicId+1,
                                        title: topicData.get('topico-titulo'),
                                        authorId: 1,
                                        movieId: 3,
                                        msg: topicData.get('topico-mensagem'),
                                        likes: 0,
                                        deslikes: 0,
                                        comments: [],
                                    }, ...topicsClone])
                                    //msg
                                    e.currentTarget.previousElementSibling.value = ''
                                    //title
                                    e.currentTarget.previousElementSibling.previousElementSibling.previousElementSibling.value= ''
                                    setCreateTopic(false)
                                }} />
                            </form>
                        </div> {/* <!-- /FORUM__CREATE -->*/}
                </div>{/*<!-- /FORUM --> */}
            </div> {/* <!-- /HOME --> */}
        </div> 
    )
}

export default Home
